/**
 * When a person was last active, from `Rws.AiInsights.Host.Activity.PersonActivityEndpoints`: the last time they used the portal and
 * the last day each provider recorded use for them. Gated on `entitlement.administer`.
 */
import { adminRequest, type AdminResult } from "./adminApi";

/** The last day a provider recorded use for the person. Mirrors `PersonProviderActivityResponse`. */
export interface PersonProviderActivity {
  vendorId: string;
  vendorDisplayName: string;
  /** An ISO date, `2026-10-20`. */
  lastSeenDay: string;
}

/** Mirrors `PersonActivityResponse`. */
export interface PersonActivity {
  /** When they last used the portal (website or a connected application); null when not since recording began. */
  portalLastSeenAt: string | null;
  /** Most recent first. */
  providers: PersonProviderActivity[];
}

/** Calls `GET /api/users/{personId}/activity`. */
export async function fetchPersonActivity(personId: string): Promise<AdminResult<PersonActivity>> {
  return adminRequest<PersonActivity>(`/api/users/${encodeURIComponent(personId)}/activity`, { method: "GET" }, "person activity");
}
